<template>
  <div class="product__configuration">
    <form @submit.prevent v-if="!outOfStockMessage">
      <div class="product__option">
        <transition name="fade">
          <div class="product-options__tooltip" v-show="showTooltip">
            <span v-if="isPackOnlyOneSquareMeter">
              {{ $t('Vloeren zijn alleen per pak te bestellen.') }}
            </span>
            <span v-else>
              {{ $t('Selecteer één van de verplichte opties.') }}
            </span>
          </div>
        </transition>
        <component :product-data="productData" :showStockNotifyAttribute="mailnotification" :is="`catalog-product-${productData.product_type}`"/>
      </div>
      <div v-if="checkSingleProduct && productData.product_volume" class="product__value">
        Inhoud: {{ productData.product_volume }}
      </div>
      <div class="product__information-container">
        <catalog-product-price position="top">
          <template #external_delivery>
            <div class="product__external_delivery" v-if="!outOfStockMessage">
              <template v-if="isPpcProduct">
                <p>
                  <slot name="ppc_shipment_time"></slot>
                  <span @click="openPopup()">Lees meer</span></p>
              </template>
              <template v-else>
                <p>
                  <slot name="shipment_time"></slot>
                </p>
              </template>
            </div>
          </template>
        </catalog-product-price>
        <div class="product__availability-container hide">
          <span class="product__stock _green" v-if="productData.in_stock || ! productData.manage_stock">{{ $t('Op voorraad') }}</span>
          <span class="product__stock _red" v-else>{{ $t('Niet op voorraad') }}</span>
        </div>
      </div>
      <div class="product__add-to-cart-container grid-container no-padding">
        <div class="grid-x grid-padding-x" :class="{ 'product__add-to-cart' : this.$mobileDetect.mobile() }">
          <div class="small-24 cell" v-show="productData.product_type === 'bundle'">
            <catalog-product-price position="bottom"></catalog-product-price>
          </div>
          <div class="product__qty cell" v-if="productData.product_type !== 'grouped'">
            <select v-model.number="selectedQuantity" name="qty" :disabled="!isSaleable ||  isLoading" v-if="qtyIsSelect">
              <option v-for="i in quantitySteps" :value="i">{{ i }}</option>
              <option value="">Meer</option>
            </select>
            <input v-model.number="selectedQuantity" type="number" name="qty" v-else/>
<!--            <input @change.prevent.stop="changeQty" v-model.number="qty" class="qty" type="number" name="qty"/>-->
          </div>
          <div class="cell auto add-to-cart__holder" @mouseenter="addToCartTooltip($event)" @mouseleave="addToCartTooltip($event)">
            <div v-if="showStockNotifyButton">
              <button class="_button _cta _cart" @click="showStockNotifyForm">{{ $t('Houd me op de hoogte') }}</button>
              <span>{{ $t('Stuur een bericht wanneer dit product weer op voorraad is') }}</span>
            </div>
            <button v-else :disabled="!isSaleable ||  isLoading" class="_button _cta _cart" @click="productAddToCart">{{ $t('In winkelwagen') }}</button>
          </div>
        </div>
      </div>
    </form>
    <div v-if="showStockNotifier && mailnotification">
      <div class="product__notify_mail">
        <div class="overlay">
          <div class="form">
            <form action="/mail-config-form" method="post" id="configmailform" novalidate>
              <div class="product__notify_mail_form">
                <div>
                  <div>
                    <button class="_button" @click="showStockNotifyForm">< {{ $t('Terug') }}</button>
                  </div>
                  <div>
                    <p>{{ $t('Stuur mij een bericht wanneer dit product weer op voorraad is') }}</p>
                  </div>
                  <div>
                    <div class="form__field">
                      <div class="_control">
                        <div>
                          <input type="text" v-model="firstname" placeholder="Voornaam" required="required" class="form-control" id="firstname" name="firstname">
                          <span class="notify-form-error" v-if="errors['firstname']">{{ errors['firstname'] }}</span>
                        </div>
                        <div>
                          <input type="text" v-model="lastname" placeholder="Achternaam" required="required" class="form-control" id="surname" name="surname">
                          <span class="notify-form-error" v-if="errors['surname']">{{ errors['surname'] }}</span>
                        </div>
                      </div>
                      <div class="_control">
                        <input type="email" v-model="email" class="form-control" required="required" placeholder="E-mailadres" id="customer_email" name="customer_email">
                        <span class="notify-form-error">{{ errors['email'] }}</span>
                      </div>
                    </div>
                    <div class="form__field__checkbox">
                      <input type="checkbox" required="required" v-model="privacy" name="privacy_statement_agreement" id="privacy_statement_agreement">
                      <label class="regular" for="privacy_statement_agreement">Ik ga akkoord met de <a target="_blank" href="/privacy-en-cookieverklaring-allesvoorparket-nl">privacy statement</a></label>
                    </div>
                    <p class="notify-form-error" v-if="errors['checkbox']">{{ errors['checkbox'] }}</p>
                    <div class="actions actions-down">
                      <button type="submit" @click.prevent="checkForm()" class="_button"><strong>Verstuur</strong></button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Component, {mixins} from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import StructuredData from '../../../shared/helpers/google-structured-data';
import {enhancedEcommerce} from '../../../shared/helpers/enhanced-ecommerce';
import {KlaviyoTracking} from '../../../shared/helpers/klaviyo';
import {isPackSizeOneSquareMeter} from '../../../shared/helpers/list-item-cart';
import axios from 'axios';
import {CartEvents, SolarDataLayer} from '@flashpointbv/solar-datalayer/dist';


@Component(
  {
    name: 'catalog-product-configuration',
    components: {
      'catalog-product-price': ServiceContainer().getComponent('catalog-product-price'),
      'catalog-product-bundle': ServiceContainer().getComponent('catalog-product-bundle'),
      'catalog-product-grouped': ServiceContainer().getComponent('catalog-product-grouped'),
      'catalog-product-configurable': ServiceContainer().getComponent('catalog-product-configurable')
    },
    mixins: [StructuredData]
  }
)

export default class extends mixins(StructuredData) {
  @Prop({default: 'field'}) private readonly qtyType: string;
  @Prop({default: false}) private readonly enableTooltip: boolean;
  @Prop({default: 1}) private qtyIncrement: number;

  @Prop() private readonly productData: object;
  @Prop() private readonly productBundleData: { selections: {}[] }[];

  private _throttle: number;
  private showTooltip: boolean = false;
  private isLoading: boolean = false;
  private showStockNotifier: boolean = false;
  private qtyIsSelect: boolean = true;
  private errors: object = {};
  private errorCount: number = 0;
  private email: String = '';
  private firstname: String = '';
  private lastname: String = '';
  private privacy: boolean = false;
  private sku: String = '';
  private sizeruler: String = '';
  protected qty: number = 1;
  protected quantitySteps: number = 10;

  private get isPackOnlyOneSquareMeter(): boolean {
    return isPackSizeOneSquareMeter(this.selectedProduct as Record<string, unknown>);
  }

  private get isSaleable(): boolean {
    if (this.isPackOnlyOneSquareMeter) {
      return false;
    }

    if (this.productData['product_type'] === 'configurable') {
      if (!this.selectedProduct) {
        return false;
      }
      return this.$store.getters['CatalogProduct/isSaleable'] && Boolean(this.selectedProduct['in_stock']);
    }

    return this.$store.getters['CatalogProduct/isSaleable'] && (this.productData['in_stock'] || !this.productData['manage_stock']);
  }

  private get selectedProduct(): object | null {
    return this.$store.getters['CatalogConfigurableProduct/selectedProducts'][0] || null;
  }

  private get selectedOptions(): Array<object> {
    return this.$store.getters['CatalogConfigurableProduct/selectedOptions'];
  }

  private get selectedProducts(): Array<object> {
    return this.$store.getters['CatalogConfigurableProduct/selectedProducts'];
  }

  private addToCartTooltip(e): void {
    if (!this.isSaleable && this.enableTooltip) {
      if (e.type === 'mouseenter') {
        this.showTooltip = true;
      } else {
        clearTimeout(this._throttle);
        this._throttle = window.setTimeout(() => {
          this.showTooltip = false;
        }, 1000);
      }
    }
  }
  private get selectedQuantity(): number {
    return this.qty;
  }

  private set selectedQuantity(value: number) {
    if (!value) {
      this.qtyIsSelect = false;
    }
    this.qty = value;
  }

  private get currentProduct(): string {
    return this.$store.getters['CatalogCategoryProduct/selectedSku'];
  }

  private get selectedProductInStock(): boolean | undefined {
    let selectedVirtualProduct: boolean | undefined;
    this.productData['virtual_products'].forEach(el => {
      if(el['sw_sizeruler_option_id'] === this.currentProduct){
        this.sizeruler = el['sw_sizeruler'];
        this.sku = el['sku'];
        selectedVirtualProduct = Boolean(el['in_stock']);
      }
    })
    return selectedVirtualProduct;
  }

  private showStockNotifyForm(): void {
    this.showStockNotifier = !this.showStockNotifier;
  }

  checkForm(): void {
    const formFields = document.querySelectorAll('.product__notify_mail_form input, .product__notify_mail_form select, .product__notify_mail_form textarea');
    this.errorCount = 0;
    this.errors = {};
    for (let i = 0; i < formFields.length; i++) {
      const el = formFields[i] as HTMLInputElement;
      if (formFields[i].hasAttribute('required')) {
        if (el.type === 'checkbox') {
          if (!el.checked) {
            this.errors['checkbox'] = 'Ga akkoord met onze privacy statement';
            this.errorCount++;
          }
        } else {
          if (el.value === '') {
            switch (el.name) {
              case 'firstname':
                this.errors['firstname'] = 'Vul je voornaam in';
                this.errorCount++;
                break;
              case 'surname':
                this.errors['surname'] = 'Vul je achternaam in';
                this.errorCount++;
                break;
              case 'customer_email':
                this.errors['email'] = 'Vul je email in';
                this.errorCount++;
                break;
            }
          }
        }
      }
    }

    const formEl = document.getElementById("configmailform") as HTMLFormElement;

    if (this.errorCount === 0){
      this.sendData();
    }
    else{
      return
    }
  }

  sendData() {
    axios.post(
      '/mail-notify-form',
      {
        email: this.email,
        firstname: this.firstname,
        lastname: this.lastname,
        privacy: this.privacy,
        configuration: localStorage.getItem('product-configuration'),
        name: this.productData['name'],
        sku: this.sku,
        sizeruler: this.sizeruler,
      },
      {headers: {'Content-Type': 'application/json'}}
    );
    this.showStockNotifyForm();
  }

  private get showStockNotifyButton(): boolean {
    if ((! this.selectedProductInStock && this.selectedProductInStock !== undefined) && this.mailnotification) {
      return true;
    }
    return false;
  }

  private get mailnotification(): boolean {
    return ('Yes' === this.productData['swff_mailnotificatie'] || 'Ja' === this.productData['swff_mailnotificatie'] );
  }

  private get isPpcProduct(): boolean {
    return this.productData.hasOwnProperty('is_ppc') &&
      this.productData['is_ppc'];
  }

  private get outOfStockMessage(): boolean {
    return this.productData.hasOwnProperty('out_of_stock_message') &&
      this.productData['out_of_stock_message'];
  }

  private async productAddToCart(): Promise<void> {
    try {
      this.isLoading = true;

      if (this.productData['product_type'] === 'grouped') {
        const selectedGroupedProducts = (this.$store.state['CatalogGroupedProduct']['selectedProducts'] || [])
          .filter(product => product['qty'] > 0);

        if (selectedGroupedProducts.length === 0) {
          this.isLoading = false;
          return;
        }

        for (let product of selectedGroupedProducts) {
          await this.$store.dispatch('CheckoutQuote/addProductToQuote', {
            sku: product['sku'],
            qty: product['qty'],
          });
          if (this.$store.getters['CheckoutQuote/getAddToCartError']) {
            break;
          }
        }
      } else {
        let productPayload = {
          sku: this.productData['sku'],
          qty: this.selectedQuantity,
        };

        if (this.productData['product_type'] === 'configurable' && this.selectedOptions.length > 0) {
          productPayload = Object.assign(productPayload, {
            product_option: {
              extension_attributes: {
                configurable_item_options: this.selectedOptions.map(option => {
                  return {
                    option_id: option['attributeId'],
                    option_value: option['selectedValue']
                  }
                })
              }
            }
          });
        }

        await this.$store.dispatch('CheckoutQuote/addProductToQuote', productPayload);
      }

      if (this.$store.getters['CheckoutQuote/getAddToCartError']) {
        const addToCartError = this.$store.getters['CheckoutQuote/getAddToCartError'];
        const message = addToCartError.message || String(this.$t('Could not add product to cart'));
        await this.$store.dispatch('CheckoutCart/setCartMessage', message);
        return;
      }

      await this.$store.dispatch('CheckoutCart/setCartMessage', null);
      await this.$store.dispatch('CheckoutCart/showCartPopup', true);
      await this.$store.dispatch('CheckoutCart/showProductAdded', true);
      SolarDataLayer.init().addAddToCart(this.productData, CartEvents.ADD, this.qty);
      if (this.productData['product_type'] === 'grouped') {
        const selectedGroupedProducts = (this.$store.state['CatalogGroupedProduct']['selectedProducts'] || [])
          .filter(product => product['qty'] > 0);
        await Promise.all(selectedGroupedProducts.map(product => KlaviyoTracking.addToCart(product, product['qty'])));
      } else {
        await KlaviyoTracking.addToCart(this.productData, this.qty);
      }
    } catch (e) {
      console.log(e);
    } finally {
      this.isLoading = false;
    }
  }

  private get checkSingleProduct(): Boolean {
    return this.$store.getters['CatalogConfigurableProduct/checkSingleProduct'];
  }

  private openPopup(): void {
    const popupEl = document.querySelectorAll('[data-popup=ppc-info]');
    popupEl[0].classList.add('_open');
    (popupEl[0] as HTMLElement).focus();
  }

  private async setTracking(): Promise<void> {
    // Clone so the tracking overrides never mutate the reactive productData
    // prop; otherwise the configurable's sku would be replaced by the
    // selected child's sku and add-to-cart would post the simple sku.
    const product = { ...this.productData };

    if(product['product_type'] === 'configurable' && this.selectedProducts.length > 0) {
      product['sku'] = this.selectedProducts[0]['sku'];
      product['url'] = `${product['url']}?sku=${this.selectedProducts[0]['sku']}`;
      product['price_incl_tax'] = this.selectedProducts[0]['price_incl_tax'];
      product['final_price_incl_tax'] = this.selectedProducts[0]['final_price_incl_tax'];
    }

    this.appendData(product);

    enhancedEcommerce.addProductDetail(product);
    KlaviyoTracking.addProductDetail(product);
    SolarDataLayer.init().addViewItem(product);
  }

  private async created(): Promise<void> {
    await this.$store.dispatch('CatalogProduct/getProductData', this.productData);
    if (this.productBundleData.length > 0) {
      await this.$store.dispatch('CatalogBundleProduct/getAvailableOptions', this.productBundleData);
    }

    //Set default stock on created
    if (this.productData['product_type'] === 'configurable') {
      await this.$store.dispatch('CatalogCategoryProduct/setSwStock', this.productData['virtual_products'].reduce((a, b) => +a + +b.sw_stock, 0));
    } else {
      await this.$store.dispatch('CatalogCategoryProduct/setSwStock', this.productData['sw_stock']);
    }

    setTimeout(() => {
      this.setTracking();
    }, 50);
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .8s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
